import type { FC } from 'react';
import type { OptimizelyProviderProps } from './optimizely.types';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import {
    OptimizelyOverrides,
    OptimizelyOverridesContext
} from './optimizelyOverrides';

export const Provider: FC<{
    optimizelyProviderProps: OptimizelyProviderProps;
    optimizelyOverrides?: OptimizelyOverrides;
}> = ({ optimizelyProviderProps, optimizelyOverrides, children }) => {
    return (
        <OptimizelyProvider {...optimizelyProviderProps}>
            <OptimizelyOverridesContext.Provider value={optimizelyOverrides}>
                {children}
            </OptimizelyOverridesContext.Provider>
        </OptimizelyProvider>
    );
};
